/* eslint-disable no-console */
import 'babel-polyfill';
import React from 'react';
import { render } from 'react-dom';
import store from './store/configureStore';
import { Provider } from 'react-redux';
import { Router, browserHistory } from 'react-router';
import registerServiceWorker from './registerServiceWorker';
import routes from './routes';

import LoadingSpinner from './components/LoadingSpinner';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import './index.css';
import './stylesheets/common.css';
// import './stylesheets/font-awesome/css/font-awesome.min.css';

store.firebaseAuthIsReady.then(() => {
  render (
    <Provider store={store}>
      <Router history={browserHistory} routes={routes} />
    </Provider>,
    document.getElementById('root')
  );
});

render(<div>
  <LoadingSpinner />
</div>, document.getElementById('root'));


// ReactDOM.render(
//   <Provider store={store}>
//     <App />
//   </Provider>, document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js